export default __webpack_public_path__ + "files/460473bcf310d651a1d68e35e484df97.png";